export default {
  title: 'Kurv',
  buttons: {
    login_to_checkout: 'Log ind for at gå til kassen',
    checkout: 'Gå til kassen',
  },
  go_to_menu: 'Gå til menuen',
  toasts: {
    cashback_points_removed: 'Din pointsaldo er ændret, så vi har fjernet pointene fra denne ordre.',
  },
};
